module.exports = __webpack_public_path__ + "static/media/platoducha-white.075e30c7.svg";